import Vue from 'vue'
import VueRouter from 'vue-router'

import { BREADCRUMB_MAPPING } from '@UTILS/breadcrumb'
import shareds from '@/assets/js/shared'
import store from '@/store'
// 處理指向相同router-link(解決重複點擊路由報錯問題)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

// 麵包屑相關Route
const breadcrumbRoute = BREADCRUMB_MAPPING.map((el) => {
  const obj = {
    path: el.path,
    name: el.route,
    component: () =>
      el.file
        ? import(`@VIEWS/${el.file}`)
        : import(`@VIEWS/${el.route.replace('-', '/')}`)
  }
  el.redirect && (obj.redirect = el.redirect)
  return obj
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@LAYOUT/GlobalLayout'),
      meta: { allowUnauthenticated: false },
      children: [
        ...breadcrumbRoute.map((route) => ({
          ...route,
          meta: { requiresAuth: true }
        })),
        {
          path: '/demo',
          name: 'Demo',
          component: () => import('@VIEWS/Demo.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      meta: { allowUnauthenticated: true },
      component: () => import('@VIEWS/Login.vue')
    },
    {
      path: '/forgetPassword',
      name: 'ForgetPassword',
      meta: { allowUnauthenticated: true },
      component: () => import('@VIEWS/ForgetPassword.vue')
    },
    {
      path: '/404',
      name: '404',
      meta: { allowUnauthenticated: true },
      component: () => import('@VIEWS/error/404')
    },
    {
      path: '*',
      meta: { allowUnauthenticated: true },
      component: () => import('@VIEWS/error/404')
    }
  ]
})

router.beforeEach(async(to, from, next) => {
  // const isLoggedIn = !!localStorage.getItem('userToken')
  const isLoggedIn = !!localStorage.getItem('userInfo')
  if (!isLoggedIn) {
    to.name !== 'Login' && to.meta.allowUnauthenticated !== true ? next({ name: 'Login' }) : next()
  } else {
    // to.name === 'Login' ? next({ name: 'Home' }) : next()
    let acl = await shareds.getAcl(store.getters['commonModule/currentCommunityId'])

    let service = null //社區服務管理
    let accessControl = null //社區門禁管理
    let video = null //社區影像管理
    let alarm = null //事件告警紀錄
    let resident = null //社區住戶管理
    let numberPlate = null //車道管理
    let deviceApplication = null //設備應用管理
    let system = null //系統管理

    if(acl){//成功取到api權限時賦予權限
      service = acl['00000000-0000-0000-0000-000000000001'] //社區服務管理
      accessControl = acl['00000000-0000-0000-0000-000000000002'] //社區門禁管理
      video = acl['00000000-0000-0000-0000-000000000003'] //社區影像管理
      alarm = acl['00000000-0000-0000-0000-000000000004'] //事件告警紀錄
      resident = acl['00000000-0000-0000-0000-000000000005'] //社區住戶管理
      numberPlate = acl['00000000-0000-0000-0000-000000000006'] //車道管理
      deviceApplication = acl['00000000-0000-0000-0000-000000000007'] //設備應用管理
      system = acl['00000000-0000-0000-0000-000000000008'] //系統管理
    }

    let service_readOnly_noacess = [//檢視權限時社區服務管理不能進入的頁面
    'service-mailPackages-send', 'service-mailPackages-add', 'service-mailPackages-edit', 'service-communityNotices-add',
    'service-communityNotices-edit', 'service-payment Notices-add', 'service-gasRegistration-add', 'service-gasRegistration-edit',
    'service-gasRegistration-register-id', 'service-publicFacilities-add', 'service-publicFacilities-id', 'service-serviceContact-add',
    'service-serviceContact-id'
    ]
    let accessControl_readOnly_noacess = [//檢視權限時社區門禁管理不能進入的頁面
    'accessControl-cardManagement-edit', 'accessControl-cardManagement-add'
    ]
    let resident_readonly_noacess = [//檢視權限時社區住戶管理不能進入的頁面
    'resident-householdManagement-add', 'resident-householdManagement-edit'
    ]
    let numberplate_readOnly_noacess = [//檢視權限時車道管理不能進入的頁面
    'numberPlate-whitelist-add', 'numberPlate-whitelist-edit'
    ]
    let deviceApplication_noacess = [//檢視、數值修改權限時設備應用管理不能進入的頁面
    'deviceApplication-automation-add'
    ]
    let system_readOnly_noacess = [//檢視權限時系統管理不能進入的頁面
    'system-account-add', 'system-account-id', 'system-field-add', 'system-field-id'
    ]

    if(to.name === 'Login'){//登入後下一頁如果是登入頁,就倒回首頁
      next({ name: 'Home' })
    }else{//登入後下一頁不是登入頁,開始判斷權限 
      if((service === 0 || !!service === false) && to.name !== 'Home' && to.name.split('-').includes ('service')){//社區服務管理[無權限 or 不存在]
        next({ name: 'Home' })
      }else if(service === 1 && to.name !== 'Home' && service_readOnly_noacess.includes (to.name)){//社區服務管理[檢視權限]
        next({ name: 'Home' })
      }else if((accessControl === 0 || !!accessControl === false) && to.name !== 'Home' && to.name.split('-').includes ('accessControl')){//社區門禁管理 [無權限 or 不存在]
        next({ name: 'Home' })
      }else if(accessControl === 1 && to.name !== 'Home' && accessControl_readOnly_noacess.includes (to.name)){//社區門禁管理 [檢視權限]
        next({ name: 'Home' })
      }else if((video === 0 || !!video === false) && to.name !== 'Home' && to.name.split('-').includes('video')){//社區影像管理 [無權限 or 不存在]
        next({ name: 'Home' })
      }else if((alarm === 0 || !!alarm === false) && to.name !== 'Home' && to.name.split('-').includes ('alarm')){//事件告警紀錄 [無權限 or 不存在]
        next({ name: 'Home' })
      }else if((resident === 0 || !!resident === false) && to.name !== 'Home' && to.name.split('-').includes('resident')){//社區住戶管理 [無權限 or 不存在]
        next({ name: 'Home' })
      }else if(resident === 1 && to.name !== 'Home' && resident_readonly_noacess.includes (to.name)){//社區住戶管理 [檢視權限]
        next({ name: 'Home' })
      }else if((numberPlate === 0 || !!numberPlate === false) && to.name !== 'Home' && to.name.split('-').includes ('numberplate')){//車道管理 [無權限 or 不存在]
        next({ name: 'Home' }) 
      }else if(numberPlate === 1 && to.name !== 'Home' && numberplate_readOnly_noacess.includes (to.name)){//車道管理 [檢視權限]
        next({ name: 'Home' })
      }else if((deviceApplication === 0 || !!deviceApplication === false) && to.name !== 'Home' && to.name.split('-').includes('deviceApplication')){//設備應用管理 [無權限 or 不存在]
        next({ name: 'Home' })
      }else if((deviceApplication === 2 || deviceApplication === 1) && to.name !== 'Home' && deviceApplication_noacess.includes (to.name)){//設備應用管理 [檢視 or 數值修改權限]
        next({ name: 'Home' })
      }else if((system === 0 || !!system === false) && to.name !== 'Home' && to.name.split('-').includes('system')){//系統管理 [無權限 or 不存在]
        next({ name: 'Home' })
      }else if(system === 1 && to.name !== 'Home' && system_readOnly_noacess.includes (to.name)){//系統管理 [檢視權限]
        next({ name: 'Home' })
      }else{
        next()
      }
    }
  }
})

export default router
